import { createFileRoute } from '@tanstack/react-router'
import AssetsGridSearch from 'Asset/components/asset/search/AssetsGridSearch'
import { claimTypesEnum } from 'User/utils/claims'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'

export const Route = createFileRoute('/assets/')({
    validateSearch: (search: Record<string, string>) => search,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_asset]}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="page" />}>
                <AssetsGridSearch />
            </Suspense>
        </Guard>
    ),
})
